// List of Modals to show
export const MODALS = {
  API: 'api',
  DATE_RANGE: 'dateRange',
  ANALYZE_DATE_RANGE: 'analyzeDateRange',
  ORDER: 'order',
  DOWNLOAD: 'download',
  STREAM: 'stream',
  LOGIN: 'login',
  NEWS: 'news',
  SAVE_SEARCH: 'saveSearch',
  SHARE: 'shareSession',
  STORIES: 'stories',
  THANK_YOU: 'thankYou',
  TOUR: 'tour',
  OUT_OF_QUOTA: 'outOfQuota',
  DOWNLOAD_AOI: 'downloadAoi',
  UPLOAD: 'upload',
  TASKING: 'taskingRedirectDialog',
  TILE_USAGE: 'tileUsageDialog',
} as const;

export type ModalsValueType = (typeof MODALS)[keyof typeof MODALS];
